import { DatePicker, Popconfirm, Popover } from 'antd';
import moment from 'moment';
import { FilledButtonStyle } from '../../styles/common.style';
import { ScheduleModalStyle } from '../AddToPlayListModal/AddToPlayListModal.style';
import Spinner from '../Spinner/Spinner';
import { useEffect, useState } from 'react';

function ScheduleRefreshModal({
  scheduleRefreshModal,
  handleScheduleModalhandleOk,
  handleScheduleModalCancel,
  scheduleDateTime,
  setScheduleDateTime,
  scheduleDateTimeDatePicker,
  setScheduleDateTimeDatePicker,
  scheduleType,
  setScheduleType,
  setOpenDatePicker,
  setdatePickeropen,
  saveRestore,
  setSaveRestore,
  scheduleLaoder,
  props, // assuming this is part of the function's signature for refreshScheduleData
  showModalDelete,
  ScheduleRefreshFn,
}) {
  const [cahngeDate, setCahngeDate] = useState(false);

  useEffect(() => {
    //@info: added this because if user is not selecting any date then it will save current date as NaN
    if (scheduleRefreshModal) {
      setScheduleDateTimeDatePicker(moment().add(3, 'minutes').toDate());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scheduleRefreshModal]);

  return (
    <ScheduleModalStyle
      visible={scheduleRefreshModal}
      onOk={handleScheduleModalhandleOk}
      footer={null}
      onCancel={handleScheduleModalCancel}
      className="ScheduleModalStyle"
    >
      {/* Paused scheduler warning banner */}
      {props.refreshScheduleData?.paused && (
        <div style={{
          background: 'linear-gradient(90deg, #ff9800 0%, #f57c00 100%)',
          color: '#fff',
          padding: '12px 16px',
          borderRadius: '8px',
          marginBottom: '16px',
          textAlign: 'center',
        }}>
          <p style={{ margin: '0 0 8px 0', fontWeight: 'bold', fontSize: '14px' }}>
            ⏸️ Scheduler Paused
          </p>
          <p style={{ margin: '0 0 8px 0', fontSize: '13px' }}>
            This scheduler is paused because your plan was downgraded.
          </p>
          <a 
            href="/settings" 
            style={{ 
              color: '#fff', 
              textDecoration: 'underline',
              fontSize: '13px',
              fontWeight: '500'
            }}
          >
            Upgrade to Unlimited to resume
          </a>
        </div>
      )}
      <div
        onClick={() => {
          console.log(scheduleDateTime);
        }}
      >
        <h1 className="heading">Schedule refresh</h1>
      </div>
      <p className="scheduleText">
        Schedule refresh playlist feature to automatically refresh daily, weekly, or monthly
        permanently updating each song's start date and time to the scheduled date and time.
      </p>
      <div className="scheduleTime">
        <div>
          <Popconfirm
            overlayClassName="schedlepopConfirm"
            icon={false}
            title={
              <div>
                <DatePicker
                  showNow={false}
                  className="scheduleInput"
                  popupClassName="schedulePopup"
                  format="DD/MM/YYYY hh:mm A"
                  showTime={{ format: 'hh:mm A' }}
                  value={scheduleDateTimeDatePicker ? moment(scheduleDateTimeDatePicker) : moment()}
                  onChange={(date, dateString) => {
                    setCahngeDate(true);
                    if (date) {
                      const formattedDate = moment(date).toDate();
                      setScheduleDateTimeDatePicker(formattedDate);
                    } else {
                      setScheduleDateTimeDatePicker(null);
                    }
                  }}
                  // Disable past dates
                  disabledDate={current => {
                    return current && current < moment().startOf('day');
                  }}
                  // Disable past times if the selected date is today
                  disabledTime={current => {
                    const now = moment();
                    if (current && current.isSame(now, 'day')) {
                      return {
                        disabledHours: () => Array.from({ length: now.hours() }, (_, i) => i),
                        disabledMinutes: () => {
                          // Disable minutes up to and including current minute for the current hour
                          if (current.hours() === now.hours()) {
                            return Array.from({ length: now.minutes() + 3 }, (_, i) => i);
                          }
                          return [];
                        },
                      };
                    }
                    return {};
                  }}
                />
              </div>
            }
            showArrow={false}
            showCancel={false}
            okText="Yes"
          >
            <Popover
              content={<p>Playlist will be refreshed daily at the scheduled time</p>}
              placement="bottomLeft"
            >
              <button
                onClick={() => {
                  setScheduleType('daily');
                  setOpenDatePicker(true);
                }}
                className={
                  scheduleType === 'daily'
                    ? 'scheduleButton scheduleButtonActive'
                    : 'scheduleButton'
                }
              >
                {' '}
                <img
                  alt="notes.svg"
                  src={'./static/Calendar.png'}
                  width="24px"
                  height="24px"
                  style={{ marginRight: '5px', cursor: 'pointer' }}
                />{' '}
                Daily{' '}
              </button>
            </Popover>
          </Popconfirm>
          {props.refreshScheduleData?.nextrefreshtTime &&
          props.refreshScheduleData?.type === 'daily' ? (
            <p className="scheduleText" style={{ textAlign: 'center', marginTop: '10px' }}>
              Next refresh : <br />
              {moment(Number(props.refreshScheduleData.nextrefreshtTime)).format(
                'DD/MM/YYYY hh:mm A'
              )}{' '}
              {Intl.DateTimeFormat().resolvedOptions().timeZone}
            </p>
          ) : null}
        </div>
        <div>
          <Popconfirm
            overlayClassName="schedlepopConfirm"
            icon={false}
            title={
              <div>
                <DatePicker
                  showNow={false}
                  className="scheduleInput"
                  popupClassName="schedulePopup"
                  format="DD/MM/YYYY hh:mm A"
                  showTime={{ format: 'hh:mm A' }}
                  value={scheduleDateTimeDatePicker ? moment(scheduleDateTimeDatePicker) : moment()}
                  onChange={(date, dateString) => {
                    setCahngeDate(true);
                    if (date) {
                      const formattedDate = moment(date).toDate();
                      setScheduleDateTimeDatePicker(formattedDate);
                    } else {
                      setScheduleDateTimeDatePicker(null);
                    }
                  }}
                  // Disable past dates
                  disabledDate={current => {
                    return current && current < moment().startOf('day');
                  }}
                  // Disable past times if the selected date is today
                  disabledTime={current => {
                    const now = moment();
                    if (current && current.isSame(now, 'day')) {
                      return {
                        disabledHours: () => Array.from({ length: now.hours() }, (_, i) => i),
                        disabledMinutes: () => {
                          // Disable minutes up to and including current minute for the current hour
                          if (current.hours() === now.hours()) {
                            return Array.from({ length: now.minutes() + 3 }, (_, i) => i);
                          }
                          return [];
                        },
                      };
                    }
                    return {};
                  }}
                />
              </div>
            }
            showArrow={false}
            showCancel={false}
            okText="Yes"
          >
            <Popover
              content={<p>Playlist will be refreshed weekly from the scheduled date and time</p>}
              placement="bottomLeft"
            >
              <button
                onClick={() => {
                  setScheduleType('week');
                  setdatePickeropen(true);
                }}
                className={
                  scheduleType === 'week' ? 'scheduleButton scheduleButtonActive' : 'scheduleButton'
                }
              >
                <img
                  alt="notes.svg"
                  src={'./static/Calendar.png'}
                  width="24px"
                  height="24px"
                  style={{ marginRight: '5px', cursor: 'pointer' }}
                />{' '}
                Weekly
              </button>
            </Popover>
          </Popconfirm>
          {props.refreshScheduleData?.nextrefreshtTime &&
          props.refreshScheduleData?.type === 'week' ? (
            <p
              onClick={() => {
                console.log(scheduleDateTime);
              }}
              className="scheduleText"
              style={{ textAlign: 'center', marginTop: '10px' }}
            >
              Next refresh:
              <br />
              {moment(Number(props.refreshScheduleData.nextrefreshtTime)).format(
                'DD/MM/YYYY hh:mm A'
              )}{' '}
              {Intl.DateTimeFormat().resolvedOptions().timeZone}
            </p>
          ) : null}
        </div>
        <div>
          <Popconfirm
            overlayClassName="schedlepopConfirm"
            icon={false}
            title={
              <div>
                <DatePicker
                  showNow={false}
                  className="scheduleInput"
                  popupClassName="schedulePopup"
                  format="DD/MM/YYYY hh:mm A"
                  showTime={{ format: 'hh:mm A' }}
                  value={scheduleDateTimeDatePicker ? moment(scheduleDateTimeDatePicker) : moment()}
                  onChange={(date, dateString) => {
                    setCahngeDate(true);
                    if (date) {
                      const formattedDate = moment(date).toDate();
                      setScheduleDateTimeDatePicker(formattedDate);
                    } else {
                      setScheduleDateTimeDatePicker(null);
                    }
                  }}
                  // Disable past dates
                  disabledDate={current => {
                    return current && current < moment().startOf('day');
                  }}
                  // Disable past times if the selected date is today
                  disabledTime={current => {
                    const now = moment();
                    if (current && current.isSame(now, 'day')) {
                      return {
                        disabledHours: () => Array.from({ length: now.hours() }, (_, i) => i),
                        disabledMinutes: () => {
                          // Disable minutes up to and including current minute for the current hour
                          if (current.hours() === now.hours()) {
                            return Array.from({ length: now.minutes() + 3 }, (_, i) => i);
                          }
                          return [];
                        },
                      };
                    }
                    return {};
                  }}
                />
              </div>
            }
            showArrow={false}
            showCancel={false}
            okText="confrim"
          >
            <Popover
              content={<p>Playlist will be refreshed monthly on the scheduled date and time</p>}
              placement="bottomLeft"
            >
              <button
                onClick={() => {
                  console.log(props.refreshScheduleData);
                  setScheduleType('month');
                  setdatePickeropen(true);
                }}
                className={
                  scheduleType === 'month'
                    ? 'scheduleButton scheduleButtonActive'
                    : 'scheduleButton'
                }
              >
                <img
                  alt="notes.svg"
                  src={'./static/Calendar.png'}
                  width="24px"
                  height="24px"
                  style={{ marginRight: '5px', cursor: 'pointer' }}
                />{' '}
                Monthly
              </button>
            </Popover>
          </Popconfirm>
          {props.refreshScheduleData?.nextrefreshtTime &&
          props.refreshScheduleData?.type === 'month' ? (
            <p className="scheduleText" style={{ textAlign: 'center', marginTop: '10px' }}>
              Next refresh : <br />
              {moment(Number(props.refreshScheduleData.nextrefreshtTime)).format(
                'DD/MM/YYYY hh:mm A'
              )}{' '}
              {Intl.DateTimeFormat().resolvedOptions().timeZone}
            </p>
          ) : null}
        </div>
      </div>
      <p className="scheduleText">
        Note: To help prevent data loss, we store up to 3 recent backups while refreshing the
        playlist. To restore a backup, go to “Restore backup” available in the header of the
        playlist when a refresh is completed.
      </p>
      <div className="footer refreshModalFooter">
        <div className="yesNoButtons">
          {props.refreshScheduleData ? (
            <div>
              <button className="scheduleButton" onClick={showModalDelete}>
                Remove schedule
              </button>
            </div>
          ) : null}
          <FilledButtonStyle
            disabled={
              props.refreshScheduleData?.paused ||
              (!cahngeDate && (scheduleLaoder || props?.refreshScheduleData?.nextrefreshtTime))
            }
            type="submit"
            className="btn2 confirmScheduleBtn"
            style={{
              width: '180px',
              cursor: (!scheduleType || props.refreshScheduleData?.paused) ? 'not-allowed !important' : 'pointer !important',
            }}
            onClick={() => {
              ScheduleRefreshFn();
            }}
          >
            {scheduleLaoder ? <Spinner /> : `Confirm`}
          </FilledButtonStyle>
        </div>
      </div>
    </ScheduleModalStyle>
  );
}

export default ScheduleRefreshModal;
